<template>
  <div class="nav_list_small_screen">
    <collapse-header
      title_img="المادة 1"
      style="display: block; position: static; border-top: 2px solid"
    >
      <b-list-group
        flush
        style="height: 55vh; overflow: hidden; overflow-y: scroll"
      >
        <b-list-group-item to="/">الرئيسية</b-list-group-item>
        <b-list-group-item style="padding: 0px">
          <app-collapse>
            <app-collapse-item title="عن المشروع" info="" style="padding: 0px">
              <b-dropdown-item to="/ministry">عن الوزارة</b-dropdown-item>
              <b-dropdown-item to="/about-platform">
                عن المنصة
              </b-dropdown-item>
            </app-collapse-item>
          </app-collapse>
        </b-list-group-item>

        <b-list-group-item style="padding: 0px">
          <app-collapse>
            <app-collapse-item
              title="المرجعيات القانونية"
              info=""
              style="padding: 0px"
            >
              <b-dropdown-item to="/legal-references/laws">
                {{ $t("ngoOrgLaw") }}</b-dropdown-item
              >
              <hr class="m-0" />
              <b-dropdown-item to="/legal-references/decrees"
                >القوانين والمراسيم المرتبطة بعمل المنظمات غير
                الحكومية</b-dropdown-item
              >
              <hr class="m-0" />
              <b-dropdown-item to="/legal-references/circulars">
                التعاميم
              </b-dropdown-item>
              <hr class="m-0" />
              <b-dropdown-item to="/legal-references/decisions">
                القرارات
              </b-dropdown-item>
              <hr class="m-0" />
              <b-dropdown-item to="/legal-references/systems"
                >الأنظمة و الأدلة</b-dropdown-item
              >
            </app-collapse-item>
          </app-collapse>
        </b-list-group-item>

        <b-list-group-item style="padding: 0px">
          <app-collapse>
            <app-collapse-item title="المنظمات" info="" style="padding: 0px">
              <b-dropdown-item to="/ngo-list">قائمة المنظمات</b-dropdown-item>
              <b-dropdown-item to="/ngos-map"
                >خريطة توزع المنظمات</b-dropdown-item
              >
            </app-collapse-item>
          </app-collapse>
        </b-list-group-item>

        <b-list-group-item to="/donation"> حملات التبرع</b-list-group-item>
        <b-list-group-item style="padding: 0px">
          <app-collapse>
            <div class="list_sp">
              <app-collapse-item title="الاستجابات الطارئة" info="">
                <b-dropdown-item to="/earthquakes"
                  >استجابة الزلازل</b-dropdown-item
                >
              </app-collapse-item>
            </div>
          </app-collapse>
        </b-list-group-item>
        <!-- <b-list-group-item to="/ngos-map">الإحصائيات</b-list-group-item> -->
        <b-list-group-item to="/general-activities">
          الفعاليات</b-list-group-item
        >
        <b-list-group-item style="padding: 0px">
          <app-collapse>
            <div class="list_sp">
              <app-collapse-item title="انضم إلينا" info="">
                <b-dropdown-item to="/jobs">فرص العمل</b-dropdown-item>
                <hr class="m-0" />
                <b-dropdown-item to="/volunteer">فرص التطوع</b-dropdown-item>
              </app-collapse-item>
            </div>
          </app-collapse>
        </b-list-group-item>
        <b-list-group-item to="/ngo-create-steps"
          >تأسيس منظمة جديدة</b-list-group-item
        >
        <b-list-group-item to="/auth/login">تسجيل الدخول</b-list-group-item>
        <!-- <b-list-group-item style="padding: 0px">
          <app-collapse>
            <app-collapse-item title="اللغة" info="">
              <b-dropdown-item to="/jobs">العربية</b-dropdown-item>
              <hr class="m-0" />
              <b-dropdown-item to="/jobs">الإنكليزية</b-dropdown-item>
            </app-collapse-item>
          </app-collapse>
        </b-list-group-item> -->
      </b-list-group>
    </collapse-header>
  </div>
</template>
<script>
import CollapseHeader from "../../../@core/components/app-collapse/CollapseHeader.vue";
import AppCollapse from "../../../@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "../../../@core/components/app-collapse/AppCollapseItem.vue";
import {
  BNav,
  BNavItem,
  BDropdown,
  BDropdownItem,
  BButton,
  BListGroupItem,
  BListGroup,
} from "bootstrap-vue";

export default {
  components: {
    //            FeatherIcon,
    BButton,
    BNav,
    BNavItem,
    BDropdown,
    BDropdownItem,
    BButton,
    // AppCollapseItem,
    CollapseHeader,
    BListGroupItem,
    BListGroup,
    AppCollapse,
    AppCollapseItem,
  },
};
</script>

<style lang="scss" scoped>
.header-button {
  margin: 0px 10px;
  align-items: center;

  span {
    margin: 0px 2px;
  }
}

.nav_list_small_screen {
  display: none;
}

.card {
  margin-bottom: 0rem;

  .card-header {
    .list-group-item {
      padding: 0px;
    }
  }
}

.card-body {
  li {
    display: flex;
  }
}

.collapse-icon [data-toggle="collapse"]::after {
}

@media (max-width: 1030px) {
  .nav_list_small_screen {
    display: inline;
  }
}
</style>
